import classNames from "classnames";
import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useContext, useState } from "react";
import {
  ItemViewModel,
  PublicRightsHolderListFilter,
} from "../../../../generated/data-contracts";
import { FormikUtils } from "../../../../utils";
import { isMobileView } from "../../../shared/appStates/appStates";
import { FilterActions } from "../../../shared/components/form";
import {
  AvisDropdown,
  AvisInputTextWithFilterType,
} from "../../../shared/components/inputs";
import { AvisContext } from "../../../shared/context/AvisContext";

interface IPublicRightsHoldersFilterFormProps {
  bag: FormikProps<PublicRightsHolderListFilter>;
  creationClasses: ItemViewModel[] | undefined;
  loading: boolean;
  filtered: boolean;
}

export function PublicRightsHoldersFilterForm(
  props: Readonly<IPublicRightsHoldersFilterFormProps>,
) {
  const { creationClasses, bag, loading } = props;
  const { res, getText } = useContext(AvisContext);
  const [acceptRightsHoldersSearchTerms, setAcceptRightsHoldersSearchTerms] =
    useState<boolean>(false);

  const widthClassName = isMobileView.value ? "col-12" : "col-6";
  const classNameSecondColumn = classNames(
    "public-rights-holder-filter-name",
    widthClassName,
  );

  const emptyFilter =
    !bag.values.rightsHolderName?.trim() && !bag.values.creationClassId;
  const disabledControls = loading || !acceptRightsHoldersSearchTerms;

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const enabledFilterButton = !(disabledControls || emptyFilter);
    if (enabledFilterButton) FormikUtils.handleEnterKeyPress(e, bag.submitForm);
  };

  return (
    <>
      <div className="public-rights-holders-accept-terms flex">
        <DotsCheckbox
          checked={acceptRightsHoldersSearchTerms}
          onChange={(_e, value) => setAcceptRightsHoldersSearchTerms(value)}
        />
        <div className="pl-2">
          {getText("portal_PUBL_RightHolderNames_Cofirm")}
        </div>
      </div>
      <div className="row">
        <AvisDropdown<ItemViewModel, PublicRightsHolderListFilter>
          className={classNameSecondColumn}
          label={res("public_RightsHolders_label_workTypes")}
          bag={bag}
          bagField="creationClassId"
          disabled={disabledControls}
          options={creationClasses}
          optionValue="id"
          optionLabel="name"
        />
      </div>
      <div className="row">
        <AvisInputTextWithFilterType<PublicRightsHolderListFilter>
          className={classNameSecondColumn}
          label={res("public_RightsHolders_label_name")}
          bag={bag}
          bagField="rightsHolderName"
          bagFieldFilterType="rightsHolderNameFilterType"
          disabled={disabledControls}
          minLength={2}
          maxLength={200}
          required
          onKeyDown={handleKeyPress}
        />
      </div>
      <FilterActions
        bag={bag}
        loading={disabledControls || emptyFilter}
        res={res}
      />
    </>
  );
}
